module.exports = function() {
  return new Worker(__webpack_public_path__ + "f896ce361c3834365b8b.worker.js");
};